import { _applyManifestFromReact } from 'App';
import { createContext, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { ammendManifestSettings } from '../../manifest/updateManifestSettings';
import { serviceWorkerHandlers, serviceWorkerInitialState, serviceWorkerReducer } from '../reducers/ServiceWorkerReducer';
import { AppSettingsContext } from './AppSettingsContext';
import { ManifestContext } from './ManifestContext';
import { PapsContext } from './PapsContext';
import { _appVersion, useServiceWorker } from './useHelpers/useServiceWorker';

export const _useSwCache = false

export const _useCache = {
  home: false,
  clients: false,
  events: false,
  settings: false
}

export const _settingSourceTypes = {
  app: 'app',
  cache: 'cache',
  database: 'database',
  reg: 'reg',
}

export const _appSettingsOriginTypes = {
  app: 'app',
  cache: 'cache',
  preview: 'preview',
  settings: 'settings',
  googleSheets: 'googleSheets',
  demo: 'demo',
}

export const ServiceWorkerContext = createContext();

const ServiceWorkerProvider = (props) => {

  const [serviceWorkerReady, setServiceWorkerReady] = useState(false);

  const swr = useServiceWorker(serviceWorkerReady)

  // appSettingsContext
  const appSettingsContext = useContext(AppSettingsContext)
  const { appSettings_state } = appSettingsContext ?? {}
  const { appConfigSettings } = appSettings_state ?? {}
  const { appNames } = appConfigSettings ?? {}
  const { appName } = appNames ?? {}

  // manifestContext
  const manifestContext = useContext(ManifestContext)
  const { manifest_state } = manifestContext ?? {}
  const { manifestIcons, settingsGlobal } = manifest_state ?? {};

  // papsContext
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}
  const { settingsDocName, appArea, pathViews } = paps_state ?? {}
  const { events: eventKey, clients: clientKey } = pathViews ?? {}

  const hash = window.location.hash;
  const hashParts = hash.split('/');
  const clientIndex = hashParts.indexOf('clients');
  const eventIndex = hashParts.indexOf('events');

  let _settingsDocName;

  if (eventIndex > -1) {
    _settingsDocName = hashParts[eventIndex + 1];
  } else if (clientIndex > -1) {
    _settingsDocName = hashParts[clientIndex + 1];
  }

  const init_state = { useSwCache: _useSwCache, currentAppVersion: _appVersion }
  const [serviceWorker_state, serviceWorker_dispatch] = useReducer(serviceWorkerReducer, serviceWorkerInitialState(init_state))

  const [manifestResponse, setManifestResponse] = useState()

  const serviceWorker_handlers = useMemo(
    () => serviceWorkerHandlers(serviceWorker_dispatch),
    [serviceWorker_dispatch]
  );

  useEffect(() => {
    serviceWorker_handlers.handleSet_serviceWorker(swr)
  }, [swr]);

  useEffect(() => {
    let hasRun = false;

    // const tryInit = () => {
    //   if (hasRun) return;
    //   hasRun = true;

    //   if (!registration) {
    //     serviceWorker_handlers.handleInit_serviceWorker(pathViews, swr);
    //   }
    // };

    const tryInit = () => {
      if (hasRun) return;
      hasRun = true;
      setServiceWorkerReady(true);
    };

    const cbAmmend = (success, mr) => {
      setManifestResponse(mr)
    }

    if (settingsGlobal && _applyManifestFromReact) {
      if (manifestIcons && !manifestResponse) {
        ammendManifestSettings(
          manifest_state,
          appName,
          cbAmmend,
          () => tryInit(), // callback after manifest update
          settingsDocName
        )
      } else {
        // Wait a short time and then fallback — manifestIcons may never appear
        const timeout = setTimeout(tryInit, 500);
        return () => clearTimeout(timeout);
      }
    } else {
      // Fallback if settingsGlobal isn't there
      tryInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manifestIcons, settingsGlobal]);

  useEffect(() => {
    serviceWorker_handlers.handleGet_cache()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appArea, clientKey, eventKey]);

  return <ServiceWorkerContext.Provider value={{ serviceWorker_state, serviceWorker_handlers, appVersion: _appVersion }}>
    {props.children}
  </ServiceWorkerContext.Provider>

};

export default ServiceWorkerProvider